import { StyleSheet } from 'aphrodite';
import { aceGray, brandPrimary, brandPrimaryHover, white } from '../../../../styles/colors';
import { borderRadius, CssSelectors, Fonts } from '../../../../styles/styles';

export const APP_BAR_HEIGHT = 72;

export const styleSheet = StyleSheet.create({
	appBar: {
		background: white,
		boxSizing: 'border-box',
		height: APP_BAR_HEIGHT,
		minHeight: APP_BAR_HEIGHT,
		zIndex: 5,
		borderBottom: `1px solid ${aceGray}`,
		padding: '0 24px',
	},
	appBarContent: {
		alignItems: 'center',
		boxSizing: 'border-box',
		display: 'flex',
		height: '100%',
		justifyContent: 'space-between',
		position: 'relative',
	},
	helpLink: {
		fontSize: 14,
		fontFamily: Fonts.lexend,
		alignItems: 'center',
		display: 'flex',
		textDecoration: 'none',
		color: brandPrimary,
		borderRadius,
		border: `1px solid ${brandPrimary}`,
		padding: '4px 8px',
		transition: 'color 0.25s ease, border-color 0.25s ease, underline 0.25s ease',
		':hover': {
			color: brandPrimaryHover,
			borderColor: brandPrimaryHover,
			textDecoration: 'underline',
		},
	},
	helpText: {
		fill: '#fff',
		fontSize: 14,
	},
	navItem: {
		flex: 1,
	},
	rightAccessoryContainer: {
		alignItems: 'center',
		display: 'flex',
		zIndex: 2,
		...CssSelectors.allChildren(
			{
				marginLeft: 20,
			},
			':not(:first-child)'
		),
	},
	toaster: {
		left: '50%',
		position: 'absolute',
		top: 17,
		transform: 'translateX(-50%)',
	},
	userProfileNav: {},
});
